<template>
  <div class="yy-container">
    <h2>分行管理</h2>
    <el-form label-position="left">
      <el-form-item>
        <el-select
          v-if="!permissions.System_Branch_Manager"
          v-model="SeledepartmentId"
          class="w120"
          filterable
          placeholder="全部分行"
          no-match-text="無匹配數據"
        >
          <el-option
            :value="1"
            label="全部分行"
          />
          <el-option
            :value="2"
            label="我的分行"
          />
        </el-select>
        <el-select
          v-model="departmentIdBind"
          class="w120"
          filterable
          placeholder="分行名稱"
          no-match-text="無匹配數據"
        >
          <template v-for="item in departmentOptions">
            <el-option
              :key="item.storeID"
              :value="item.storeID"
              :label="item.storeName"
            />
          </template>
        </el-select>
        <el-button
          type="danger"
          @click="QueryDepartment"
        >
          搜尋
        </el-button>
        <el-button
          native-type="reset"
          class="yy-reset"
          style="width: 88px"
          @click="reset"
        >
          重置
        </el-button>
      </el-form-item>
      <div class="yy-line" />
      <el-form-item v-if="permissions.System_Branch_Manager">
        <div
          class="btn-icon"
          title="新增分行"
        >
          <svg
            class="icon"
            style="width: 1.5em; height: 1.5em"
            aria-hidden="true"
            @click="addDepartment('new')"
          >
            <use xlink:href="#iconxinzengfenhang-copy" />
          </svg>
          <span
            class="add"
            @click="addDepartment('new')"
          >新增分行</span>
        </div>
        <div class="yy-x-line" />
        <div class="yy-operations">
          <a
            title="更改"
            class="btn-icon"
            @click="addDepartment(departmentId)"
          >
            <svg
              class="icon"
              aria-hidden="true"
              style="width: 1.5em; height: 1.5em"
            >
              <use :xlink:href="!departmentId || selected ? '#iconxiugai' : '#iconxiugai-copy'" />
            </svg>
            <span>修改</span>
          </a>
          <a
            title="刪除"
            class="btn-icon"
            @click="openDialog(departmentId)"
          >
            <svg
              class="icon"
              aria-hidden="true"
              style="width: 1.5em; height: 1.5em"
            >
              <use :xlink:href="!departmentId || selected ? '#iconshanchu1' : '#iconshanchu1-copy'" />
            </svg>
            <span>删除</span>
          </a>
        </div>
      </el-form-item>
      <!-- 分行管理员 -->
      <el-form-item v-if="!permissions.System_Branch_Manager">
        <div class="yy-operations">
          <a
            title="更改"
            class="btn-icon"
            @click="addDepartment(departmentId)"
          >
            <svg
              class="icon"
              aria-hidden="true"
              style="width: 1.5em; height: 1.5em"
            >
              <use :xlink:href="!departmentId || selected ? '#iconxiugai' : '#iconxiugai-copy'" />
            </svg>
            <span>修改</span>
          </a>
        </div>
      </el-form-item>
    </el-form>

    <div class="table-wrapper">
      <el-table
        ref="yyTab"
        v-loading="loading"
        :data="departmentData"
        empty-text="暫無數據"
        @select="handleSelection"
        @select-all="handleSelectionAll"
      >
        <el-table-column
          type="selection"
          :selectable="checkboxSelect"
        />
        <el-table-column
          :width="13 * 20"
          prop="storeName"
          label="分行名稱"
          :formatter="emptyText"
        />
        <el-table-column
          :width="13 * 9"
          prop="storeTelephone"
          label="分行電話"
          :formatter="emptyText"
        />
        <el-table-column
          :width="13 * 8"
          prop="label"
          label="分行標籤"
          :formatter="emptyText"
        />
        <el-table-column
          prop="addressWithCulture"
          label="分行地址"
          :formatter="emptyText"
        />
        <el-table-column label="組別">
          <template slot-scope="scope">
            <div v-if="scope.row.departments === null ? false : scope.row.departments.length">
              <p
                v-for="(items, index) in scope.row.departments"
                :key="index"
                class="depart"
              >
                <el-tooltip
                  v-if="items.departmentName && items.departmentName.length > 15"
                  placement="top"
                  :content="items.departmentName"
                >
                  <span>{{ items.departmentName.substring(0, 14) + '...' }}</span>
                </el-tooltip>
                <span v-else>{{ items.departmentName }}</span>
              </p>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
      </el-table>

      <el-footer>
        <!-- 底部分页 -->
        <div class="yy-record">
          <!-- <div class="yy-count">
                    <div>共<span>{{this.queryCount}}</span>條</div>
                    <div>總記錄:<span>{{departCount}}</span></div>
                </div> -->
          <el-pagination
            background
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total,sizes, prev, pager, next, jumper"
            :total="queryCount"
            @current-change="handleCurrent"
            @size-change="handlePageSizeChange"
          />
        </div>
      </el-footer>
    </div>
    <!-- 删除对话框 -->
    <!-- <el-dialog
        title="警告"
        :visible.sync="dialogVisible"
        width="30%">
        <span>確認刪除該分行嗎？</span>
        <span slot="footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="delDepartment(record)">確 認</el-button>
        </span>
    </el-dialog> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: 'DepartmentManage',
    data() {
        return {
            selected: false,
            pageIndex: 1,
            pageCount: 10,
            departCount: 0,
            queryCount: 0,
            departmentOptions: [],
            departmentData: [],
            departmentId: null,
            departmentIdBind: null,
            SeledepartmentId: 1,

            companyId: 0,
            loading: false,
            // dialogVisible:false,
            record: 0,
            currentPage: 1,
            pageSize: 10,
            queryParam: {
                companyID: 0,
                pageIndex: 1,
                pageCount: 10,
                selfStore: null
            }
        };
    },
    computed: {
        ...mapGetters(['userInfo', 'permissions'])
    },
    created() {
        this.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'departPageCount') || 10;
        this.queryParam.pageCount = this.pageCount
        this.pageSize = this.pageCount
        this.getDepartments().then(() => {
            this.queryParam.companyID = this.companyId;
        });
        console.log(this.permissions, 'permissions');
    },
    methods: {
        checkboxSelect(row, rowIndex) {
            // console.log(row, rowIndex,'checkboxSelect');
            if (row.allowUpdate) {
                return true; // 禁用
            } 
                return false; // 不禁用
            
        },

        handleSelectionAll(selection) {
            this.$refs.yyTab.clearSelection();
            this.selected = true;

        },
        handleSelection(selection, row) {
            console.log(selection, row, 'selection');
            this.$refs.yyTab.clearSelection();
            if (selection.length === 0) {
                this.selected = true;
                this.departmentId = '';
                return;
            } 
                this.selected = false;
            
            this.$refs.yyTab.toggleRowSelection(row);
            this.departmentId = row.storeID;
        },
        emptyText(row, column) {
            if (column.property == 'storeName') {
                if (row.storeName) {
                    return row.storeName;
                }
            } else if (column.property == 'storeTelephone') {
                if (row.storeTelephone) {
                    return row.storeTelephone.substring(0, 4) + ' ' + row.storeTelephone.substring(4, 8);
                }
            } else if (column.property == 'label') {
                if (row.label) {
                    return row.label;
                }
            } else if (column.property == 'addressWithCulture') {
                if (row.addressWithCulture) {
                    return row.addressWithCulture;
                }
            }
            return '-';
        },
        // 翻頁操作
        handleCurrent(index) {
            this.currentPage = index;
            this.queryParam.pageIndex = this.currentPage;
            // this.queryParam.storeID = this.departmentId ? this.departmentId : '';
            this.queryParam.storeID = '';
            this.selected = true;
            this.handleDepartData();
        },
        // 切換每頁顯示條目數量
        handlePageSizeChange(size) {
            this.pub.userPageSize(this.$store.state.userInfo.accountID,'departPageCount',size) 
            if (!this.queryParam.storeID) {
                this.pageSize = size;
                this.queryParam.pageCount = this.pageSize;
            } else {
                this.pageSize = size;
                this.queryParam.pageCount = this.pageSize;
                this.queryParam.storeID = this.departmentId ? this.departmentId : '';
            }
            this.handleDepartData();
        },
        addDepartment(index) {
            if (!index) {
                return;
            } else if (index == 'new') {
                this.$router.push({
                    name: 'addDepartment',
                    query: {
                        companyId: this.companyId
                    }
                });
            } else {
                this.$router.push({
                    name: 'addDepartment',
                    query: {
                        storeId: index,
                        companyId: this.companyId
                    }
                });
            }
        },
        openDialog(index) {
            if (!this.departmentId) {
                return;
            }
            this.record = index;
            this.$confirm('確認刪除該分行嗎?', '提示', {
                confirmButtonText: '確認',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.delDepartment(this.record);
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消刪除',
                        showClose: true
                    });
                });
            // this.dialogVisible=true
        },
        async delDepartment(record) {
            // 刪除該條記錄
            const del = await this.axios.get(this.pub.getApi().RemoveStore, {
                params: {
                    storeID: record
                }
            });
            if (del.data.code == 0 && del.data.result) {
                // 刪除成功
                // this.dialogVisible=false
                this.$message({
                    message: '刪除成功',
                    type: 'success',
                    showClose: true
                });
                this.getCurrentDepartment(this.currentPage, this.pageSize).then(() => {
                    this.departCount -= 1;
                    this.queryCount = this.departCount;
                    this.departmentId = '';
                    if (!this.departmentData.length) {
                        this.getCurrentDepartment(this.currentPage - 1, this.pageSize);
                    } else {
                        return;
                    }
                });
            } else if (del.data.code == 2025) {
                // this.dialogVisible=false
                this.$message({
                    message: '該分行已關聯組別，無法刪除',
                    type: 'error',
                    showClose: true
                });
            } else {
                // this.dialogVisible=false
                this.$message({
                    message: '刪除失敗',
                    type: 'error',
                    showClose: true
                });
            }
        },
        // 重置按鈕
        reset(data) {
            console.log(data, 'myclass');
            this.departmentId = null;
            this.departmentIdBind = null;
            this.currentPage = 1;
            this.pageSize = 10;
            this.queryParam.pageIndex = this.currentPage;
            this.queryParam.pageCount = this.pageSize;
            this.queryParam.storeID = this.departmentId;
            this.SeledepartmentId = 1;
            if (data == 'myClass') {
                this.queryParam.selfStore = true;
            } else {
                this.queryParam.selfStore = false;
            }
            this.loading = true;
            console.log(this.queryParam, 'queryParam');
            this.handleDepartData();
        },
        // 查詢按鈕
        async QueryDepartment() {
            // this.SeledepartmentId = '';
            if (this.departmentIdBind || this.SeledepartmentId) {
                console.log('进来执行了');
                this.queryParam.storeID = this.departmentIdBind;
                this.currentPage = 1;
                this.queryParam.pageIndex = this.currentPage;
                this.queryParam.selfStore = this.SeledepartmentId === 2 ? true : false;

                this.handleDepartData().then(() => {
                    // this.$refs.yyTab.toggleAllSelection(true);
                    this.selected = true;
                });
            }
        },
        // 首次獲取列表
        async getDepartments() {
            this.loading = true;
            this.companyId = this.userInfo.companyID;
            const departInfo = await this.axios.post(this.pub.getApi().SearchStore, {
                companyID: this.companyId,
                pageIndex: this.pageIndex,
                pageCount: this.pageCount
            });
            if (departInfo.data.code == 0 && departInfo.data.result) {
                this.departCount = departInfo.data.result.count;
                this.queryCount = this.departCount;
                this.departmentOptions = departInfo.data.result.data;
            }
            this.departmentData = this.departmentOptions;
            while (this.departmentOptions.length < this.departCount) {
                this.pageIndex++;
                const departInfoCopy = await this.axios.post(this.pub.getApi().SearchStore, {
                    companyID: this.companyId,
                    pageIndex: this.pageIndex,
                    pageCount: this.pageCount
                });
                if (departInfoCopy.data.code == 0 && departInfoCopy.data.result) {
                    const departs = departInfoCopy.data.result.data;
                    this.departmentOptions = this.departmentOptions.concat(departs);
                }
            }
            this.loading = false;
        },
        async getCurrentDepartment(current, count) {
            const departInfo = await this.axios.post(this.pub.getApi().SearchStore, {
                companyID: this.companyId,
                pageIndex: current,
                pageCount: count
            });
            if (departInfo.data.code == 0 && departInfo.data.result) {
                this.departmentOptions = departInfo.data.result.data;
            }
            this.departmentData = this.departmentOptions;
        },
        async handleDepartData() {
            const departInfo = await this.axios.post(this.pub.getApi().SearchStore, this.queryParam);
            if (departInfo.data.code == 0 && departInfo.data.result) {
                this.queryCount = departInfo.data.result.count;
                this.departmentData = departInfo.data.result.data;
                this.loading = false;
            }
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/element-reset.less';
.yy-container {
    width: 100%;
    height: 100%;
    text-align: left;
    .w120 {
        width: 120px;
    }
    h2 {
        font-weight: normal;
    }
    .el-form-item__content {
        .el-select {
            margin-right: 30px;
            /deep/.el-input__inner {
                border-radius: 10px;
                color: #000;
                font-size: 14px;
            }
        }
    }
    .el-button {
        border-radius: 10px;
    }
    .el-button--danger {
        background: #e50113;
        border: none;
        width: 88px;
    }
    .yy-reset {
        background-color: #bbbbbb;
        border: none;
        color: #ffffff;
    }
    .yy-line {
        width: 100%;
        height: 1px;
        background: #e2e2ea;
        margin: 20px 0;
    }
    .btn-icon {
        display: inline-block;
        margin-right: 20px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        .add {
            color: #0062ff;
        }
        > span {
            padding-left: 5px;
        }
    }
    .yy-x-line {
        margin: 0 20px 0 0;
    }
    .yy-x-line {
        display: inline-block;
        width: 1px;
        height: 20px;
        vertical-align: middle;
        background: #e2e2ea;
    }
    .yy-operations {
        display: inline-block;
    }
    /deep/.table-wrapper {
        width: 100%;
        background-color: #fff;
        border-radius: 20px;
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
        color: #44444f;
        font-size: 14px;
        margin-bottom: 20px;
        /deep/.el-table__header-wrapper {
            thead {
                .el-table-column--selection {
                    .el-checkbox {
                        visibility: hidden;
                    }
                }
            }
        }
        .el-table__row {
            &:hover {
                td {
                    background-color: rgba(80, 181, 255, 0.1);
                }
            }
            td {
                border-bottom: 1px solid #e2e2ea;
                .cell {
                    line-height: 24px;
                }
            }
            .el-checkbox__input.is-checked {
                .el-checkbox__inner {
                    background-color: #0062ff;
                    border-color: #0062ff;
                }
            }
            color: #222222;
        }
    }
    .el-footer {
        text-align: left;
        font-size: 13px;
        margin: 10px 0;
        padding: 0;
        .yy-record {
            display: flex;
            justify-content: flex-end;
            .yy-count {
                line-height: 48px;
                display: flex;
                div {
                    margin-right: 20px;
                    span {
                        color: #0066ff;
                    }
                }
            }
        }
        .el-pagination {
            padding: 10px 0;
        }
    }
}
// @media screen and(min-width: 1280px){
//     // 大屏幕
//     .btn-text{
//         display: inline-block;
//         margin-right: 15px;
//     }
//     .btn-icon{
//         display: none;
//     }
//     .yy-x-line{
//         margin: 0 30px;
//     }
// }
// @media screen and(max-width: 1280px){
//     // 小屏幕
//     .btn-text{
//         display: none;
//     }
//     .btn-icon{
//         display: inline-block;
//         margin-right: 20px;
//     }
//     .yy-x-line{
//         margin:0 20px 0 0;
//     }
// }
</style>
